import sha256 from 'crypto-js/sha256';
import { iTrack } from '../types/ITrack';

/**
 * Generates a track ID for a given track.
 * Creates a hash of the normalized (trimmed) title and artist.
 * IMPORTANT: Always use trimmed values to ensure consistent hashing across the app.
 */
export const generateTrackID = (track: iTrack): string =>
  sha256(
    JSON.stringify({
      artist: track.Artist?.trim() ?? '',
      title: track.Title?.trim() ?? '',
    }),
  ).toString() || track.ID;
